import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import { registerField } from 'core/forms';

import { ColorInput } from 'uikit/inputs';

const FormFieldColor = ({ fieldId, schema = {}, updateField = () => {}, value = '' }) => (
  <ColorInput
    ariaLabel={schema.ariaLabel}
    buttonAriaLabel={schema.buttonAriaLabel}
    className={schema.className}
    id={fieldId}
    isDisabled={schema.isDisabled}
    isReadOnly={schema.isReadOnly}
    name={schema.name}
    onChange={updateField}
    placeholderColor={schema.placeholderColor}
    placeholderInput={schema.placeholderInput}
    testId={schema.testId || `${fieldId}-color-input`}
    value={value ?? ''}
  />
);

FormFieldColor.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    ariaLabel: PropTypes.string,
    buttonAriaLabel: PropTypes.string,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    name: PropTypes.string,
    placeholderColor: PropTypes.string,
    placeholderInput: PropTypes.string,
    testId: PropTypes.string,
  }),
  updateField: PropTypes.func,
  value: PropTypes.string,
};

registerField('Color', React.memo(FormFieldColor));

export default FormFieldColor;
